<template>
    <div class="content industry">
        <div class="industry-list" >
            
            <div class="industry-item industry-item1" @click="gotoDetail(1)" >
                <div class="title">产业专区</div>
                <div class="sub-title">Industry Area</div>
            </div>

            <div class="industry-item industry-item2" @click="gotoDetail(2)" >
                <div class="title">港澳专区</div>
                <div class="sub-title">Hong Kong and Macau Area</div>
            </div>

            <div class="industry-item industry-item3" @click="gotoDetail(3)" >
                <div class="title">省实验室专区</div>
                <div class="sub-title">Provincial Lab Area</div>
            </div>

            <div class="industry-item industry-item4" @click="gotoDetail(4)" >
                <div class="title">百千万工程专区</div>
                <div class="sub-title"></div>
            </div>
           
        </div>
    </div>
</template>

<script>
import {ref, onMounted, getCurrentInstance} from 'vue'
export default {
    setup(){
        const {proxy} = getCurrentInstance();
        const industries = ref([]);
        const loading = ref(false)

       
        // console.log('aa')

        return  {industries, loading}
    },
    methods:{
        gotoDetail(zoneClass){
            if(zoneClass == 1){
                this.$router.push({name: 'Industry', path: 'industry', query: {zoneClass: zoneClass}})
            }else if(zoneClass == 4){
                this.$router.push({path: '/baiqianwan/home', query: {zoneClass: zoneClass}})
            }
           
        }
    },
}
</script>

<style lang="less" scoped>

.industry-item1{
    background-image: url(/static/img/si1.png);
}
.industry-item2{
    background-image: url(/static/img/si2.png);
}
.industry-item3{
    background-image: url(/static/img/si3.png);
}
.industry-item4{
    background-image: url(/static/img/si5.png);
}

.industry{
    padding-top: 30px;
    margin-bottom: 112px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .industry-list{

        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        

        .industry-item{

            width: 589px;
            height: 185px;
            background-size: 589px 185px;
            background-position: 0 0;
            text-align: center;
            position: relative;
            cursor: pointer; 
            margin-bottom: 25px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .title{
            text-align: center;
            font-family: SourceHanSansCN-Bold;
            font-size: 36px;
            line-height: 36px;
            color: #FFFFFF;
            text-shadow: 0 2px 3px rgba(0,0,0,0.50);
        }
        .sub-title{
            font-family: SourceHanSansCN-Regular;
            font-size: 16px;
            line-height: 16px;
            margin-top: 6px;
            color: #FFFFFF;
            text-shadow: 0 2px 3px rgba(0,0,0,0.50);
        }
    }
}
</style>


